//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'user',
    },
    id: {
      type: String,
      required: true,
    },
    avatar: {
      type: Object,
      default() {},
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
      required: true,
    },
    gender: {
      type: String,
      default: '',
    },
    subline: {
      type: String,
      default: '',
    },
    videoLink: {
      type: String,
      default: '',
    },
    shortDescription: {
      type: String,
      default: '',
    },
    aboutMentor: {
      type: String,
      default: '',
    },
    location: {
      type: Object,
      default() {},
    },
    languages: {
      type: Array,
      default() {},
    },
    stats: {
      type: Array,
      default() {},
    },
    text: {
      type: String,
      default: '',
    },
    hearingJourneyNew: {
      type: Array,
      default() {},
    },
    forumId: {
      type: [Number, String],
      default: '',
    },
    forum: {
      type: Object,
      default() {
        return {
          topics: [],
          posts: [],
          groups: [],
        }
      },
    },
  },
  data() {
    return {
      mobileView: false,
    }
  },
  computed: {
    shouldRenderTabs() {
      return this.hearingJourneyNew.length > 0 && !this.mobileView
    },
    shouldRenderAccordion() {
      return this.hearingJourneyNew.length > 0 && this.mobileView
    },
    embeddedYoutubeUrl() {
      return this.videoLink
        ? this.videoLink.replace('watch?v=', 'embed/')
        : false
    },
  },
  mounted() {
    this.mobileView = window.innerWidth < 768
    window.addEventListener('resize', () => {
      this.mobileView = window.innerWidth < 768
    })
  },
}
